import React from "react";
import { useLocation, Link, Switch, Route } from "react-router-dom";

import { Title, Tab } from "rbx";

import {
  BillingVerified,
  InvoiceGenerated,
  ExportedToAccounting,
  ImportedInAccounting
} from "./routes";

import "./InvoiceGenerationPage.scss";

const InvoiceGenerationPage = () => {
  const location = useLocation();
  return (
    <div>
      <header className="page-head">
        <div className="page-head-start">
          <Title>Invoice Generation</Title>
        </div>
      </header>
      <Tab.Group kind="boxed">
        <Tab
          active={new RegExp(/billing-verified$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-generation/billing-verified"
        >
          <span>Billing Verified</span>
        </Tab>
        <Tab
          active={new RegExp(/invoice-generated$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-generation/invoice-generated"
        >
          <span>Invoice Generated</span>
        </Tab>
        <Tab
          active={new RegExp(/exported-to-accounting$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-generation/exported-to-accounting"
        >
          <span>Exported To Accounting</span>
        </Tab>
        <Tab
          active={new RegExp(/imported-in-accounting$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-generation/imported-in-accounting"
        >
          <span>Imported In Accounting</span>
        </Tab>
      </Tab.Group>
      <Switch>
        <Route path="/finance/invoice-generation/billing-verified">
          <BillingVerified />
        </Route>
        <Route path="/finance/invoice-generation/invoice-generated">
          <InvoiceGenerated />
        </Route>
        <Route path="/finance/invoice-generation/exported-to-accounting">
          <ExportedToAccounting />
        </Route>
        <Route path="/finance/invoice-generation/imported-in-accounting">
          <ImportedInAccounting />
        </Route>
      </Switch>
    </div>
  );
};
export default InvoiceGenerationPage;
